export const mapSelectValueToBoolean = (value: string): boolean | null => {
  if (value === '') return null;

  return value === 'true';
};

export const mapBooleanToSelectValue = (value: boolean | null): string => {
  if (value == null) return '';

  return String(value);
};
